/** @module SiteAdmin/Comment/Attach */
define([
	"dojo/_base/declare",
	"dojo/_base/array",
	"csi/action/NewFileController",
	"csi/html",
	"csi/image/_base",
	"csi/reflection",
	"csi/xml"
], function(declare, array, NewFileController, html, csiImage, reflection, xml) {

	return declare(NewFileController, {
		bInterrupt: true,

		/**
		 * Select files to attach
		 */
		onPreActionDeferreds: function(dfds) {
			var self = this;

			dfds.push(html.selectFiles().then(function(files) {
				self.actionValue = files;
			}));
		},

		/**
		 * @override
		 * Modify parameters for upload operation
		 */
		onUploadRequest: function(req) {
			req.addParameter("URL", this.m_urlNode);
			req.addParameter("NewNodeAttrId", "Images");
			req.addParameter("NewFileAttrId", "Files");
		},

		getNodeTypesForFileNames: function(/*String[]*/fileNames) {
			// summary: return an array of types of wrapping nodes which must be created for the each file published
			return array.map(fileNames, function(fileName) {return csiImage.isValidFormat(fileName) ? reflection.TYPE_IMAGE : "";});
		},

		postProcessSuccess: function() {
			// summary: refresh heading and update view
			var view = this.widget;
			view.refreshHeading(view.defView.defsByKey.Date, this.m_urlNode);
			view.refreshHeading(view.defView.defsByKey.Attachments, this.m_urlNode);
		}
	});
});